export const QuestionTypesOpinometroActionTypes = {
  API_RESPONSE_SUCCESS: '@@question-type-opinometro/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@question-type-opinometro/API_RESPONSE_ERROR',

  GET_QUESTION_TYPE_OPINOMETRO: '@@question-type-opinometro/GET_QUESTION_TYPE_OPINOMETRO',
  LIST_QUESTION_TYPES_OPINOMETRO: '@@question-type-opinometro/LIST_QUESTION_TYPES_OPINOMETRO',
  ADD_QUESTION_TYPE_OPINOMETRO: '@@question-type-opinometro/ADD_QUESTION_TYPE_OPINOMETRO',
  UPDATE_QUESTION_TYPE_OPINOMETRO: '@@question-type-opinometro/UPDATE_QUESTION_TYPE_OPINOMETRO',
  DELETE_QUESTION_TYPE_OPINOMETRO: '@@question-type-opinometro/DELETE_QUESTION_TYPE_OPINOMETRO',

  RESET: '@@question-type-opinometro/RESET'
}
